import React, { useState } from 'react';
import { message } from 'antd';
import { downloadDocumentLibraryFolder } from '@gtintel/platform-api';
import { zipAndDownloadDocumentLibraryFolder } from '../../../downloadFile';
import { DownloadButton } from './styles';
const DownloadRootButton = ({
  projectId
}) => {
  const [loading, setLoading] = useState(false);
  const downloadDocLib = () => {
    setLoading(true);
    message.success('Your download is being prepared. This might take a while.');
    const responseHandler = zipAndDownloadDocumentLibraryFolder.bind(this, `GTI-project-${projectId}`);
    downloadDocumentLibraryFolder({
      folder: '',
      projectId
    }).then(responseHandler).catch(error => {
      console.error(error);
      message.error('Something went wrong while preparing the download. Please contact an admin!');
    }).finally(() => setLoading(false));
  };
  return <DownloadButton data-public disabled={loading} type="default" size="small" onClick={downloadDocLib} data-testid="download-file-button">
      Download All
    </DownloadButton>;
};
export default DownloadRootButton;